import { AccessTime, Done, DoneAll, Error, ScheduleSend } from "@mui/icons-material";
import { green, red } from "@mui/material/colors";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => {
    return {
        ackIcons: {
            fontSize: 18,
            verticalAlign: "middle",
            marginLeft: 4,
        },
        ackDoneAllIcon: {
            color: green[500],
            fontSize: 18,
            verticalAlign: "middle",
            marginLeft: 4,
        },
        ackErrorIcon: {
            color: red[400],
            fontSize: 15,
            verticalAlign: "middle",
            marginLeft: 4,
        },
    }
});

const RenderAck = ({ message }) => {
    const { classes } = useStyles();

    if (message.ack === 0) {
        return <AccessTime fontSize="small" className={classes.ackIcons} />;
    }
    if (message.ack === 1) {
        return <Done fontSize="small" className={classes.ackIcons} />;
    }
    if (message.ack === 2) {
        return <DoneAll fontSize="small" className={classes.ackIcons} />;
    }
    if (message.ack === 3 || message.ack === 4) {
        return <DoneAll fontSize="small" className={classes.ackDoneAllIcon} />;
    }
    if (message.ack === 5) {
        return <Error fontSize="small" className={classes.ackErrorIcon} />;
    }
    if (message.ack === 7) {
        return <ScheduleSend fontSize="small" className={classes.ackIcons} />;
    }
};

export default RenderAck;